<template lang="pug">
#MineralFilter
    div(v-for="(mineral,id) in minerals").mb1
        .pretty.p-default.p-smooth(v-if="mineral.show")
            input(type="checkbox" v-model="selected[id]")
            .state
                label
                    .pill.ml1(:style="{ backgroundColor: mineral.color}")
                    | {{mineral.name}}
    .pretty.p-default.p-smooth.mt3
        input(type="checkbox"  v-model="selectAll")
        .state
            label {{ selectAll ? 'Unselect all' : 'Select all' }}
    p.note(:class="{noteRelevant}")
        span.dib.fl.pt2 ⚠️
        span.dib.v-bottom.ml2(style="width:320px") Raster layers hidden. Choose a single mineral type to show rasters.

</template>

<script>
import { EventBus } from '../EventBus';
export default {
    name: 'MineralFilter',
    data: function() {
        const out = { selected: {}, selectAll: false };
        for (const mineralId of Object.keys(this.minerals).filter(
            m => this.minerals[m].show
        )) {
            out.selected[mineralId] = true;
        }
        out.selected.other = false;
        out.selected.unknown = false;
        return out;
    },
    props: ['minerals'],
    created() {
        window.MineralFilter = this;
    },
    computed: {
        noteRelevant() {
            return Object.values(this.selected).filter(Boolean).length > 1;
        }
    },
    watch: {
        selected: {
            deep: true,
            // immediate: true,
            // todo make this sync with initial state
            handler() {
                EventBus.$emit('mineral-filter', this.selected);
            }
        },
        selectAll() {
            for (const mineral of Object.keys(this.minerals).filter(
                m => this.minerals[m].show
            )) {
                this.selected[mineral] = this.selectAll;
            }
        }
    },
    mounted() {
        this.$nextTick(() => EventBus.$emit('mineral-filter', this.selected));
    }
};
// require('pretty-checkbox');
</script>

<style scoped>
.pill {
    width: 14px;
    height: 14px;
    border-radius: 7px;
    display: inline-block;
    margin-right: 5px;
    border: 1px solid black;
}

.note {
    opacity: 0;
    /* color: #888; */
}
.noteRelevant {
    /* color: hsl(24, 100%, 50%); */
    color: white;
    opacity: 1;
}
</style>
